import React, { createContext, useState } from "react";

const context = createContext();

const currenciesMap = {
  USD: { label: "USD", rate: 1, sign: "$" },
  EUR: { label: "EUR", rate: 1 / 1.08, sign: "€" },
  RUB: { label: "RUB", rate: 73.5, sign: "₽" },
  UAH: { label: "UAH", rate: 26.5, sign: "₴" }
};

const currencies = Object.entries(currenciesMap).map(([key, { label }]) => ({
  key,
  label
}));

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState("USD");
  const { rate, sign } = currenciesMap[currency];
  const m = amount => `${(rate * amount).toFixed(2)} ${sign}`;

  return (
    <context.Provider value={{ currencies, currency, setCurrency, m }}>
      {children}
    </context.Provider>
  );
}

export default context;
